import me from "models/me";
import { PriceEntity } from "containers/admin/promotions/entity/price-entity/promotions.types";
import { THRESHOLD_FOLDER, THRESHOLD_SUFFIX } from "containers/admin/promotions/utils/consts";

export const updateDuplicatedEntity = (entityForUpdate: PriceEntity, newName: string, newId: string) => ({
    ...entityForUpdate,
    actions: entityForUpdate.actions.map((action) => ({
        ...action,
        price_action: {
            ...action.price_action,
            price_code: `discounts|${newId}`,
        },
    })),
    name: newName,
    id: newId,
    created_by: me.email,
    enabled: false,
});

export const updateDuplicatedThresholdEntity = (entityForUpdate: PriceEntity, newName: string, newId: string) => ({
    ...entityForUpdate,
    actions: entityForUpdate.actions.map((action) => ({
        ...action,
        price_action: {
            ...action.price_action,
            price_code: `threshold|${newId}`,
        },
    })),
    name: newName,
    id: `${newId}${THRESHOLD_SUFFIX}`,
    created_by: me.email,
    folder: THRESHOLD_FOLDER,
    enabled: false,
});
